module.exports = __webpack_public_path__ + "img/arrow-y.87585acb.svg";